import OrganizationsInfiniteScrollFilter from './OrganizationsInfiniteScrollFilter';

export default OrganizationsInfiniteScrollFilter;
